import { actionCreators } from "../../state";
import { AuthStorage } from "../../storage/auth";
import { AuthInterface } from "./adapters/api/Interface";
import { AuthStorageInterface } from "./adapters/storage/storage";
import jwtDecode from "jwt-decode";

export class AuthorizationUseCases {
    private api: AuthInterface;
    private stateActions: typeof actionCreators;
    private storage: AuthStorageInterface;

    constructor(api: AuthInterface, stateActions: typeof actionCreators) {
        this.api = api;
        this.stateActions = stateActions;
        this.storage = new AuthStorage();

    }

    public SignIn = async (login: Login, pass: Pass) => {
        this.stateActions.SendLoginRequest()
        let response = await this.api.SignIn({ login, pass })
        if (!(response instanceof Error)) {
            this.storage.SaveToken(response.token)
            this.storage.SaveRefreshToken(response.refreshToken)
            this.stateActions.LoginSuccess()
        } else {
            let error = "ошибка авторизации"
            this.stateActions.LoginError(error)
        }
    }

    public CheckAuthorization = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{ exp: number }>(token)
            let currentDate = new Date();
            if (decoded.exp * 1000 < currentDate.getTime()) {
                this.stateActions.LoginError("")
                localStorage.removeItem("token")
            } else {
                this.stateActions.LoginSuccess()
            }
        } else {
            this.stateActions.LoginError("")
            localStorage.removeItem("token")
        }
    }

    public IsAdminUser = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "admin") {
                return true
            }
            return false
        } else {
            return false
        }

    }

    public IsHeadOfContactCenter = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "head_of_contact_center") {
                return true
            }
            return false
        } else {
            return false
        }

    }

    public IsHeadOfGroup = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "head_of_group") {
                return true
            }
            return false
        } else {
            return false
        }

    }

    public IsHr = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "hr") {
                return true
            }
            return false
        } else {
            return false
        }

    }

    public UserId = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{user_id: string}>(token)
            
            return decoded.user_id
        } else {
            return ""
        }

    }

    public IsROO = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "roo") {
                return true
            }
            return false
        } else {
            return false
        }
    }

    public GetUserRole = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            return decoded.role
        }
    }

    public GetTransId = () => {
        let token = this.storage.ReadToken();
        if (token) {
            let decoded = jwtDecode<{responsible_trans_id: string}>(token);
            if (decoded.responsible_trans_id ) {
                return parseInt(decoded.responsible_trans_id);
            }
            return false;
        } else {
            return false;
        }
    }

    public IsTeamLead = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{role: string}>(token)
            if (decoded.role === "team_lead") {
                return true
            }
            return false
        } else {
            return false
        }

    }

    public DecodeToken = () => {
        let token = this.storage.ReadToken()
        if (token) {
            let decoded = jwtDecode<{access_list: string[],}>(token)
            return decoded.access_list
        } else {
            return []
        }

    }

    public LogOut = () => {
        this.storage.DeleteToken()
        this.stateActions.LoginError("")
    }
}